<template>
    <span class="text-primary">
        <i
            class="fa fa-check-circle-o fa-lg icon-button"
            title="Marcar como processada"
            @click.stop="confirmarProcessado()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        solicitacaoAditivo: {
            type: Object,
            default: () => {}
        },

        solicitacoesAditivosServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarProcessado() {
            this.$swal({
                title: 'Solicitação de Aditivo Processada',
                html: `Confirma que a solicitação de aditivo da contratação ${this.solicitacaoAditivo.codContratacao} foi processada?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.processar()
                }
            })
        },

        processar() {
            this.$store.dispatch('addRequest')
            this.solicitacoesAditivosServicos
                .processar(this.solicitacaoAditivo.solicitacaoAditivoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação de aditivo processada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizar-listagem')
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar a solicitação do aditivo',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
